import { MainLayout } from 'components/Layout';
import { useEffect } from 'react';

export const MarketplaceTerms = () => {
  useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // change to 'auto' if you want instant
      });
    }, []);
  return (
    <MainLayout
      title="Marketplace Terms | Fundo"
      description="Rules governing buying, selling, and trading on the Fundo marketplace."
    >
      {/* HEADER */}
      <section className="max-w-3xl">
        <p className="text-xs uppercase tracking-[0.35em] text-[#8b5e3c]">Marketplace Terms</p>

        <h1 className="mt-4 font-serif text-5xl leading-[0.95] tracking-[-0.04em] text-[#1b140f] sm:text-6xl">
          Rules for trading on Fundo.
        </h1>

        <p className="mt-6 text-lg leading-8 text-[#4f4034]">
          These terms govern all buying, selling, and auction activity on the Fundo marketplace.
        </p>

        <p className="mt-4 text-sm text-[#8b5e3c]">Last updated: April 2026</p>
      </section>

      {/* CONTENT */}
      <section className="mt-20 max-w-3xl space-y-14">
        {/* ROLE */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">1. Platform Role</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Fundo provides a platform that connects buyers and sellers. Fundo does not own, store,
            or take responsibility for goods listed or sold through the marketplace.
          </p>
        </div>

        {/* LISTINGS */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">2. Listings</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Sellers are responsible for ensuring that all listings are accurate, complete, and not
            misleading. This includes product descriptions, quantities, pricing, and availability.
          </p>
        </div>

        {/* PRICING */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">3. Pricing</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Prices are determined by sellers or through auction mechanisms. Fundo does not set or
            control pricing and is not responsible for pricing disputes.
          </p>
        </div>

        {/* AUCTIONS */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">4. Auctions</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Auctions may be conducted on the platform. By placing a bid, you agree to complete the
            transaction if your bid is successful. Sellers agree to honor the highest valid bid at
            the close of the auction.
          </p>
        </div>

        {/* TRANSACTIONS */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">5. Transactions & Fulfillment</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Buyers and sellers are solely responsible for completing transactions, including
            delivery, collection, and payment arrangements unless otherwise specified within the
            platform.
          </p>
        </div>

        {/* PAYMENTS */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">6. Payments</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Payment services may be facilitated by third-party providers. Fundo does not guarantee
            payment processing or settlement and is not liable for payment-related issues.
          </p>
        </div>

        {/* DISPUTES */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">7. Disputes</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Disputes between buyers and sellers should be resolved directly between the parties.
            Fundo may provide limited support but is not obligated to mediate or resolve disputes.
          </p>
        </div>

        {/* PROHIBITED */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">8. Prohibited Conduct</h2>
          <ul className="mt-4 space-y-3 text-sm text-[#4f4034]">
            <li>• Listing false or misleading products</li>
            <li>• Manipulating auction outcomes</li>
            <li>• Non-fulfillment after a confirmed transaction</li>
            <li>• Fraudulent or deceptive behavior</li>
          </ul>
        </div>

        {/* LIABILITY */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">9. Limitation of Liability</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Fundo is not liable for losses arising from marketplace transactions, including product
            quality, delivery issues, or payment disputes.
          </p>
        </div>

        {/* SUSPENSION */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">10. Suspension & Removal</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Fundo reserves the right to remove listings or suspend accounts that violate these terms
            or harm the integrity of the marketplace.
          </p>
        </div>

        {/* UPDATES */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">11. Changes to Marketplace Terms</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            These terms may be updated periodically. Continued use of the marketplace indicates
            acceptance of any changes.
          </p>
        </div>

        {/* CONTACT */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">12. Contact</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            For marketplace-related inquiries, contact:
          </p>

          <p className="mt-4 text-sm text-[#8b5e3c]">fundofarmer@gmail.com</p>
        </div>
      </section>
    </MainLayout>
  );
};
